<template lang="pug">
    .page_det
        .loading2(v-if="loading" )
        .private(v-else-if="isPrivate" )
            input.inp(placeholder="私密家谱，请输入密码访问" maxlength="4" v-model="privateCode" ref="Private" @keyup.enter="getPrivateData")
            .btn(@click="getPrivateData") 确定
        .data_bk(v-else)   
            .full   
                .treeboxfull(:class="{isEdit:isEdit && treeSet && treeSet.name}")
                    .tree
                        TreeChart(:json="treeDemo" :treeSet="treeSet" :v-dragscroll="true")

</template>

<script>
import {regId, regPhone} from '../utils/validate'
import {mapGetters} from "vuex"
import FeelingBar from './mo_feeling'
import TreeChart from "./mo_tree";
import CONT from '../utils/const'
import mapSet from '@/views/mo_map_set'
import dialogconfirm from '@/views/mo_confirm'

export default {
    components: {
        FeelingBar, TreeChart, mapSet, dialogconfirm
    },
    data() {
        return {
            loading: true,
            treeSet: null,
            isPrivate: false,
            queryPrivate: false,
        }
    },
    mounted() {
        this.queryPrivate = this.$route.query.isPrivate
        if(this.queryPrivate){
            var code = this.$getStorage('private' + this.$route.query.id)
            if(code){
                this.isPrivate = false;
                this.loading = true;
                this.getData(code)
            }else{
                this.isPrivate = true;
                this.loading = false;
            }
        }else{
            this.isPrivate = false;
            this.loading = true;
            this.getData(0)
        }
    },
    computed: {
        ...mapGetters(["calen", "userInfo"])
    },
    methods: {
       
        getPrivateData() {
            if (this.privateCode) {
                this.getData(this.privateCode)
            } else {
                this.$toast.error('请输入密码访问');
                this.$refs.Private.focus()
            }
        },

        getData(code) {
            const id = this.$route.query.id;
            if (!id) {
                return false;
            }
            if (regId(id)) {
                if (!code && this.$getStorage('private' + this.$route.query.id)) {
                    code = this.$getStorage('private' + this.$route.query.id)
                }
                this.$get('article/' + this.$route.query.id + '/' + (code || 0)).then((res) => {
                    if(this.queryPrivate){
                        this.$setStorage('private' + this.$route.query.id, code)
                    }
                    this.form = res;
                    // this.$toast(res.user.nickname)
                    document.title = res.ancestor + '家谱-' + res.address
                    this.isPrivate = false
                    this.loading = false
                    if (res.tree) {
                        this.treeDemo = JSON.parse(res.tree)
                    }
                    if (!res.tree && res.ancestorId) {
                        this.$get('people/' + res.ancestorId).then((res2) => {
                            if (res2) {
                                this.treeDemo = {
                                    id: res2.id,
                                    root: true,
                                    name: res2.name,
                                    sex: res2.sex,
                                    clan: res2.clan,
                                    address: res2.address,
                                    birthAt: res2.birthAt,
                                    deathAt: res2.deathAt
                                }
                            }
                        }).catch()
                    }
                }).catch((err) => {
                    if (err && err.data) {
                        if (err.data.statusCode === 406) {
                            this.isPrivate = true
                            localStorage.removeItem('private' + this.$route.query.id)
                        }
                        if (err.data.statusCode === 418) {
                            this.$router.push('/article')
                        }
                    }
                })
            } else {
                this.$toast('找不到该页面');
                this.$router.push('/mine/article')
            }
        },
        
    },
    
    activated() {

    },
    deactivated() {

    }
}
</script>
